import { Pipe, PipeTransform } from '@angular/core';

import { IProduct } from '../../shared/models/product.model';

@Pipe({
    name: 'showBadgeNew',
    standalone: false
})
export class ShowBadgeNewPipe implements PipeTransform {

  transform(products: IProduct[]): boolean {
    return products?.some(product => product?.newProduct);
  }

}
